import Blue from "~/core";
import Swiper from "swiper";
import {
  Navigation,
  A11y,
} from "swiper/modules";

Swiper.use([Navigation, A11y]);

new Blue({
	name: 'Testimonial Cards',
	selector: ".testimonial-cards",
	setup(cards) {
        const ref = this;
        const moreTest = cards.querySelector('.testimonial-cards__more-testimonials');

        if (moreTest && cards.querySelectorAll('.swiper-slide').length > 3) {
            moreTest.classList.add('has-more');
            moreTest.addEventListener('click', () => {
                cards.classList.toggle('show-more');
            });
        }

        let swiper;
        function slick() {
            swiper = new Swiper(cards.querySelector('.swiper'), {
                watchOverflow: true,
                slidesPerView: 3,
                spaceBetween: 30,
                navigation: {
                    nextEl: cards.querySelector('.swiper-button-next'),
                    prevEl: cards.querySelector('.swiper-button-prev'),
                }
            });
        }
		
		if(ref.$screen.md.matches) {
			slick();
		}

		this.$addEvents(window, 'resize', () => {
			if(!swiper && ref.$screen.md.matches) {
				slick();
			} else if (swiper && !ref.$screen.md.matches) {
                swiper.destroy();
                swiper = null;
			}
		})
	}
});

new Blue({
	name: 'Testimonial Card',
	selector: ".testimonial-card",
	setup(card) {
		const quote = card.querySelector('.testimonial-card__quote-text');
		const showMore = card.querySelector('.testimonial-card__show-more');

        if (!quote || !showMore) return;

		const showMoreSpan = showMore.querySelector('span');
        const quoteSpan = quote.querySelector('span');
        const fullQuote = quote.dataset.fullQuote;
        const shortQuote = quoteSpan.innerText;

        let expanded = false;

        if (fullQuote) {
            card.classList.add('testimonial-card--expandable');

            showMore.addEventListener('click', () => {
                expanded = !expanded;
                card.classList.toggle('expanded', expanded);
                quoteSpan.innerText = expanded ? fullQuote : shortQuote;
                showMoreSpan.innerText = expanded ? 'See Less' : 'See More';
            });
        }
	}
});